import { css } from 'styled-components';
import { ArrayToType } from '../utils';

export const PositionArray = ['top', 'right', 'bottom', 'left'] as const;
export type PositionType = ArrayToType<typeof PositionArray>;

export const padding = (arr: Array<number>) => css`
  padding: ${arr.map(item => `${item}px `)} !important;
`;

export const paddingValue = (value: number, position: PositionType) => `padding-${position}: ${value}px !important`;

export const margin = (arr: Array<number>) => css`
  margin: ${arr.map(item => `${item}px `)} !important;
`;

export const marginValue = (value: number, position: PositionType) => `margin-${position}: ${value}px !important`;

export interface SpacingProps {
  p?: Array<number>;
  pt?: number;
  pr?: number;
  pb?: number;
  pl?: number;
  m?: Array<number>;
  mt?: number;
  mr?: number;
  mb?: number;
  ml?: number;
}

export const spacingStyle = ({ m, mt, mr, mb, ml, p, pt, pr, pb, pl }: SpacingProps) => css`
  ${m && margin(m)};
  ${mt && marginValue(mt, 'top')};
  ${mr && marginValue(mr, 'right')};
  ${mb && marginValue(mb, 'bottom')};
  ${ml && marginValue(ml, 'left')};
  ${p && padding(p)};
  ${pt && paddingValue(pt, 'top')};
  ${pr && paddingValue(pr, 'right')};
  ${pb && paddingValue(pb, 'bottom')};
  ${pl && paddingValue(pl, 'left')};
`;
